export default {
  SPIN: 'TIRAR',
  'You are not eligible for free spins':
    'Solo las cuentas de Steam con juego CSGO y sin VAC pueden optar a monedas gratuitas. Vuelve a iniciar sesión en el sitio para actualizar.',
  'It must be 24 hours since last roll': 'Deben pasar 24 horas desde la última tirada.',
};
